import React from 'react';
import { gql, useQuery } from '@apollo/client';

import {
  Box,
  Link,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from '@mui/material';
import moment from 'moment';
import { moneyPrint } from '@pv/common/utils';
import { appHost } from '@pv/common/api';
const APP_HOST = appHost(process.env.REACT_APP_PV_ENV as string);
const adminVenuePaymentsQuery = gql`
  query AdminVenuePayments($id: ID!) {
    adminVenue(id: $id) {
      id
      payments(limit: 20) {
        id
        amount
        createdAt
        paidAt
        kind
        event {
          id
          name
        }
        processorPaymentId
        paymentProvider
        chargedOnProcessorAccountId
        state
        paymentReportTypeLabel
      }
    }
  }
`;

interface Payment {
  id: string;
  amount: number;
  createdAt: string;
  paidAt: string;
  kind: string;
  event: { id: string; name: string };
  processorPaymentId: string;
  chargedOnProcessorAccountId: string;
  paymentProvider: string;
  state: string;
  paymentReportTypeLabel: string;
}
interface Venue {
  id: string;
  name: string;
  defaultPaymentProvider: string;
  achEnabled: boolean;
  paymentsEnabled: boolean;
}

export const PaymentsTable = ({ venue }: { venue: Venue }) => {
  const { data } = useQuery(adminVenuePaymentsQuery, {
    variables: { id: venue.id },
  });
  const payments = data?.adminVenue?.payments || [];
  if (payments.length === 0) {
    return (
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>
          No payments collected yet
        </Typography>
      </Paper>
    );
  }
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Recent Event Payments
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>Paid At</TableCell>
              <TableCell>Kind</TableCell>
              <TableCell>Event</TableCell>
              <TableCell>Event ID</TableCell>
              <TableCell>Processor Payment ID</TableCell>
              <TableCell>Charged On Account ID</TableCell>
              <TableCell>State</TableCell>
              <TableCell>Method</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {payments.map((payment: Payment) => (
              <TableRow key={payment.id}>
                <TableCell>{payment.id}</TableCell>
                <TableCell>{moneyPrint(payment.amount / 100.0)}</TableCell>
                <TableCell>
                  {moment(payment.createdAt).format('MMM D, YYYY h:mm A')}
                </TableCell>
                <TableCell>
                  {payment.paidAt
                    ? moment(payment.paidAt).format('MMM D, YYYY')
                    : ''}
                </TableCell>
                <TableCell>{payment.kind}</TableCell>
                <TableCell>{payment.event.name}</TableCell>
                <TableCell>
                  <Link
                    href={`${APP_HOST}/events/${payment.event.id}/payments`}
                  >
                    {payment.event.id}
                  </Link>
                </TableCell>
                <TableCell>{payment.processorPaymentId}</TableCell>
                <TableCell>{payment.chargedOnProcessorAccountId}</TableCell>
                <TableCell>{payment.state}</TableCell>
                <TableCell>{payment.paymentReportTypeLabel}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
